<template>
    <div class="sa-sidebar sidebar primary" :class="{ show: sideBarState }">
        <fa
            v-if="sideBarState"
            icon="fa-xmark"
            class="icon-close"
            @click="changeSideBarState"
        />

        <div class="sidebar-header">
            <div class="header-logo">
                <div class="logo" id="desktopLogoWeflix">
                    <img
                        class="logo_black"
                        src="./../../assets/logo-tutor.png"
                        alt="Weeduc"
                    >
                </div>
                <div class="logo-mobile">
                    <span>
                        <img src="./../../assets/Weflix/icons/Weflix-Icone-Branco.svg" alt="">
                    </span>
                    <span class="mobile-icon-weflix-text">
                        <img src="./../../assets/Weflix/icons/Weflix-Escrita-Branco.svg" alt="">
                    </span>
                </div>
            </div>
        </div>

        <div class="sidebar-content">
            <nav class="content-link" aria-label="Menu Super Admin">
                <div class="link">
                    <router-link
                        class="link-content primary"
                        to="/admin/dashboard"
                        :class="{ active: activeIndex == 0 }"
                        @click="setActiveIndex(0)"
                    >
                        <span class="link-icon"><fa icon="fa-chart-line" /></span>
                        <span class="link-text"><span class="text">Dashboard</span></span>
                    </router-link>
                </div>
                <div class="link">
                    <router-link
                        class="link-content primary"
                        to="/admin/relatorios"
                        :class="{ active: activeIndex == 4 }"
                        @click="setActiveIndex(4)"
                    >
                        <span class="link-icon"><fa icon="fa-chart-pie" /></span>
                        <span class="link-text"><span class="text">Análise e Relatórios</span></span>
                    </router-link>
                </div>
                <div class="link">
                    <router-link
                        class="link-content primary"
                        to="/super-admin"
                        :class="{ active: activeIndex == 2 }"
                        @click="setActiveIndex(2)"
                    >
                        <span class="link-icon"><fa icon="fa-building-columns" /></span>
                        <span class="link-text"><span class="text">Nova Empresa</span></span>
                    </router-link>
                </div>
                <div class="link">
                    <router-link
                        class="link-content primary"
                        to="/admin/empresas"
                        :class="{ active: activeIndex == 1 }"
                        @click="setActiveIndex(1)"
                    >
                        <span class="link-icon"><fa icon="fa-building" /></span>
                        <span class="link-text"><span class="text">Lista de Empresas</span></span>
                    </router-link>
                </div>
                <div class="link">
                    <router-link
                        class="link-content primary"
                        to="/admin/aprovar-vendas"
                        :class="{ active: activeIndex == 3 }"
                        @click="setActiveIndex(3)"
                    >
                        <span class="link-icon"><fa icon="fa-check-circle" /></span>
                        <span class="link-text"><span class="text">Aprovações</span></span>
                    </router-link>
                </div>
                <div class="link">
                    <router-link
                        class="link-content primary"
                        to="/admin/usuarios"
                        :class="{ active: activeIndex == 5 }"
                        @click="setActiveIndex(5)"
                    >
                        <span class="link-icon"><fa icon="fa-users" /></span>
                        <span class="link-text"><span class="text">Usuários</span></span>
                    </router-link>
                </div>
            </nav>
        </div>

        <div class="sidebar-footer">
            <button
                type="button"
                class="link-content primary link-content--logout"
                @click="logout"
            >
                <span class="link-icon"><fa icon="fa-sign-out-alt" /></span>
                <span class="link-text"><span class="text">Sair</span></span>
            </button>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    data() {
        return {
            activeIndex: 0,
            routeActiveMap: {
                '/admin/dashboard': 0,
                '/admin/empresas': 1,
                '/super-admin': 2,
                '/admin/aprovar-vendas': 3,
                '/admin/relatorios': 4,
                '/admin/usuarios': 5,
            },
        };
    },
    computed: {
        ...mapState(['sideBarState']),
    },
    watch: {
        '$route.path': {
            immediate: true,
            handler(path) {
                this.syncActiveFromRoute(path);
            },
        },
    },
    methods: {
        ...mapActions(['storeSideBarState', 'logoutSuperAdmin']),

        changeSideBarState() {
            this.storeSideBarState({ sideBarState: !this.sideBarState });
        },
        syncActiveFromRoute(path) {
            const exact = this.routeActiveMap[path];
            if (exact != null) {
                this.activeIndex = exact;
                localStorage.setItem('activeIndex', this.activeIndex);
                return;
            }
            if (path.startsWith('/editar-empresa') || path.startsWith('/personalizar-empresa')) {
                this.activeIndex = 1;
                localStorage.setItem('activeIndex', this.activeIndex);
            }
        },
        setActiveIndex(index) {
            this.activeIndex = index;
            localStorage.setItem('activeIndex', this.activeIndex);
        },
        async logout() {
            await this.logoutSuperAdmin();
            localStorage.removeItem('activeIndex');
            this.$router.push('/admin');
        },
    },
    created() {
        this.syncActiveFromRoute(this.$route.path);
    },
};
</script>

<style scoped>
.sa-sidebar.sidebar.primary {
    --sa-sidebar-bg: #260791;
    --sa-sidebar-active: #150065;
    --sa-sidebar-hover: rgba(21, 0, 101, 0.72);
    --sa-sidebar-text: rgba(255, 255, 255, 0.94);
    --sa-sidebar-muted: rgba(255, 255, 255, 0.72);

    position: fixed;
    top: 0;
    left: 0;
    z-index: 1040;
    width: 15%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 0.75rem 0.65rem 0.75rem;
    background-color: var(--sa-sidebar-bg);
    border-right: 1px solid rgba(255, 255, 255, 0.08);
    font-family: Inter, system-ui, -apple-system, 'Segoe UI', sans-serif;
    box-sizing: border-box;
}

.sa-sidebar .sidebar-header {
    flex-shrink: 0;
    padding: 0.85rem 0.55rem 1rem !important;
    margin: 0 0 0.5rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.sa-sidebar .header-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 40px;
}

.sa-sidebar .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.sa-sidebar .logo img {
    width: auto;
    max-width: 132px;
    height: auto;
    max-height: 36px;
    object-fit: contain;
    display: block;
}

.sa-sidebar .logo-mobile {
    display: none;
}

.sa-sidebar .sidebar-content {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-top: 0;
    height: auto;
}

.sa-sidebar .content-link {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    flex: 1 1 auto;
    min-height: 0 !important;
    height: auto !important;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0.15rem 0 0.5rem;
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.22) transparent;
}

.sa-sidebar .content-link::-webkit-scrollbar {
    width: 4px;
}

.sa-sidebar .content-link::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 99px;
}

.sa-sidebar .link {
    display: block;
}

.sa-sidebar .link-content {
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    gap: 0;
    font-style: normal;
    font-weight: 500;
    font-size: 0.8125rem;
    line-height: 1.35;
    letter-spacing: 0.01em;
    text-decoration: none;
    padding: 0.55rem 0.7rem 0.55rem 0.55rem;
    color: var(--sa-sidebar-text);
    border-radius: 10px;
    transition: background-color 0.2s ease, color 0.15s ease;
}

.sa-sidebar .link-content:focus-visible {
    outline: 2px solid rgba(199, 182, 254, 0.85);
    outline-offset: 1px;
}

.sa-sidebar .link-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 1.75rem;
    height: 1.75rem;
    margin-right: 0.65rem;
    color: #fff;
}

.sa-sidebar .link-icon :deep(svg) {
    width: 0.95rem;
    height: 0.95rem;
    font-size: 0.95rem;
}

.sa-sidebar .link-text {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: flex-start;
    min-width: 0;
}

.sa-sidebar .link-text .text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.sa-sidebar .link-content.active,
.sa-sidebar .link-content.router-link-exact-active {
    background-color: var(--sa-sidebar-active);
    color: #fff;
}

.sa-sidebar .link-content:hover {
    color: #fff;
    background-color: var(--sa-sidebar-hover);
}

.sa-sidebar .link-content.active:hover,
.sa-sidebar .link-content.router-link-exact-active:hover {
    background-color: var(--sa-sidebar-active);
}

.sa-sidebar .sidebar-footer {
    flex-shrink: 0;
    margin-top: auto;
    padding: 0.65rem 0 0.15rem;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.sa-sidebar .link-content--logout {
    width: 100%;
    border: 0;
    background: transparent;
    cursor: pointer;
    font: inherit;
    text-align: left;
    color: var(--sa-sidebar-muted);
}

.sa-sidebar .link-content--logout:hover {
    color: #fff;
    background-color: rgba(255, 255, 255, 0.08);
}

.sa-sidebar.show {
    width: 220px;
}

.sa-sidebar .icon-close {
    position: absolute;
    top: 0.85rem;
    right: 0.75rem;
    color: #fff;
    cursor: pointer;
    z-index: 2;
    padding: 0.25rem;
}

@media only screen and (min-width: 1900px) {
    .sa-sidebar.sidebar.primary {
        box-shadow: 2px 0 22px -12px rgba(0, 0, 0, 0.35);
    }

    .sa-sidebar .logo img {
        max-width: 148px;
        max-height: 40px;
    }
}

@media (max-width: 500px) {
    .sa-sidebar.sidebar.primary {
        width: 60px;
        padding: 0.55rem 0.35rem;
        transition: width 0.35s ease;
    }

    .sa-sidebar.show {
        width: 72%;
        max-width: 280px;
    }

    .sa-sidebar .sidebar-header {
        padding: 0.65rem 0.25rem 0.85rem !important;
    }

    #desktopLogoWeflix {
        display: none;
    }

    .sa-sidebar .logo-mobile {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.65rem;
        width: 100%;
    }

    .sa-sidebar:not(.show) .logo-mobile .mobile-icon-weflix-text {
        display: none;
    }

    .sa-sidebar .logo-mobile img {
        width: 28px;
        height: auto;
    }

    .sa-sidebar .mobile-icon-weflix-text {
        width: 72px;
        display: flex;
        align-items: center;
    }

    .sa-sidebar .mobile-icon-weflix-text img {
        width: 100%;
        height: auto;
    }

    .sa-sidebar:not(.show) .link-text {
        display: none;
    }

    .sa-sidebar:not(.show) .link-content {
        justify-content: center;
        padding: 0.55rem;
    }

    .sa-sidebar:not(.show) .link-icon {
        margin-right: 0;
    }

    .sa-sidebar.show .link-content {
        padding: 0.55rem 0.7rem 0.55rem 0.55rem;
    }

    .sa-sidebar .link-content.active {
        border-radius: 10px;
    }
}
</style>
